import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const estadoProyectoService = {
  getAll,
}

async function getAll() {
  return await ApiBudgety.get('EstadoProyecto/GetAll/')
}
